import { ApiResponse } from "../../../types/api.types";
import axiosClient from "../../../utils/axios";
import { NotificationInboxResponse, NotificationMessage } from "../types/notification.types";

/* Dropdown notifications (latest messages) */
export const getInboxNotifications = async ({
  page,
  limit,
}: {
  page?: number;
  limit?: number;
}) => {
  try {
    const response = await axiosClient.post<
      ApiResponse<NotificationInboxResponse>
    >("/message/inbox", {
      page,
      limit,
    });

    return response.data;
  } catch (err) {
    console.warn("Error fetching Inbox Notifications :", err);
    throw err;
  }
};

/* Full inbox list page */
export const getMessageList = async ({
  page,
  limit,
  search,
  recipient_id,
}: {
  page?: number;
  limit?: number;
  search?: string;
  recipient_id: number;
}) => {
  try {
    const response = await axiosClient.post<
      ApiResponse<NotificationInboxResponse>
    >("/message/list", {
      page,
      limit,
      search,
      recipient_id,
    });

    return response.data;
  } catch (err) {
    console.warn("Error fetching message list :", err);
    throw err;
  }
};

/* Conversation thread */
export const getInboxConversation = async ({
  page,
  limit,
  recipient_id,
}: {
  page?: number;
  limit?: number;
  recipient_id: number;
}) => {
  try {
    const response = await axiosClient.post<
      ApiResponse<NotificationInboxResponse>
    >("/message/inbox-view", {
      page,
      limit,
      recipient_id,
    });

    return response.data;
  } catch (err) {
    console.warn("Error fetching Inbox Conversation :", err);
    throw err;
  }
};

/* View single message */
export const getMessageView = async (id: number) => {
  try {
    const response = await axiosClient.post<
      ApiResponse<NotificationMessage>
    >("/message/vew", {
      id,
    });

    return response.data;
  } catch (err) {
    console.warn("Error fetching message view :", err);
    throw err;
  }
};

export const deleteMessage = async (id: number) => {
  try {
    const response = await axiosClient.post<ApiResponse<any>>(
      "/message/delete",
      {
        id,
      }
    );

    return response.data;
  } catch (err) {
    console.warn("Error deleting message :", err);
    throw err;
  }
};